/*
 * SELF - stany, etykiety i NIP w przegladarce (modul MP, E4.14 / E4.15; PROJEKT-E4 D17, D19, A-7, K-19).
 *
 * Dlaczego w JS, a nie w Liquid: strona moze przyjsc z cache, a `'now' | date` w Liquid pokazuje czas
 * RENDERU (A-7). Swiezosc stanow (SHOP self.stany_aktualne_do jako epoch w data-*) i waznosc recznego
 * nadpisania etykiety (custom.override_do) liczymy tu wzgledem Date.now().
 *
 * Zasada bezpieczenstwa (D19, MOT-34 "falszywa rzadkosc"): bez swiezych danych nie ma stanu "low"
 * ("Ostatnie sztuki") ani automatycznej etykiety "Ostatnie rozmiary". Brak pola, zly format, data
 * z przyszlosci ponad tolerancje = dane NIE sa swieze.
 *
 * Plik dziala dwa razy bezpiecznie (snippety MP wstawiaja go przy sobie, docelowo jest tez w layout):
 * straznik `window.SelfStany.wersja`. Elementy dodane pozniej (Section Rendering API: zmiana wariantu
 * podmienia innerHTML #Inventory-*, filtry podmieniaja siatke, szuflada koszyka) lapie MutationObserver.
 *
 * NIP (E4.14, 1.1.0): pole niesie formularz koszyka (`form` + `attributes[NIP]`), zmiana zapisuje atrybut w tle
 * (/cart/update.js), a "Do kasy" (submit formularza koszyka, faza capture) jest zatrzymywane przy blednym NIP-ie
 * albo pustym polu przy zaznaczonej fakturze. Logika decyzji w czystej funkcji `decyzjaNip`.
 *
 * Czyste funkcje sa testowane w Node: tests/unit/stany.test.mjs, tests/unit/etykieta.test.mjs (vm).
 * Zero odwolan do pol wewnetrznych sklepu (lint: self_ops zakazane).
 */
(function (root) {
  'use strict';

  if (root.SelfStany && root.SelfStany.wersja) return;

  var GODZINA_MS = 3600000;
  var TOLERANCJA_PRZYSZLOSCI_MS = 15 * 60000;

  var ETYKIETY = ['Drop', 'Nowość', 'Znów dostępne', 'Bestseller', 'Ostatnie rozmiary'];
  var BEZ_ETYKIETY = 'Bez etykiety';
  var KLASY = {
    Drop: 'drop',
    'Nowość': 'nowosc',
    'Znów dostępne': 'znow-dostepne',
    Bestseller: 'bestseller',
    'Ostatnie rozmiary': 'ostatnie-rozmiary',
  };

  function liczba(x) {
    if (x === '' || x === null || x === undefined || typeof x === 'boolean') return NaN;
    var n = Number(x);
    return isFinite(n) ? n : NaN;
  }

  function prawda(x) {
    return x === true || x === 'true' || x === '1';
  }

  // Czy ostatni bieg stanow (epoch w sekundach) jest mlodszy niz prog w godzinach.
  function swieze(epochSek, progH, teraz) {
    var e = liczba(epochSek);
    var p = liczba(progH);
    var t = liczba(teraz);
    if (!(e > 0) || !(p > 0) || !(t > 0)) return false;
    var wiek = t - e * 1000;
    return wiek >= -TOLERANCJA_PRZYSZLOSCI_MS && wiek <= p * GODZINA_MS;
  }

  // Stan wybranego wariantu: 'out' | 'low' | 'in'. 'low' TYLKO przy swiezych danych (K-19).
  function stanWariantu(o) {
    o = o || {};
    if (!prawda(o.dostepny)) return 'out';
    var il = liczba(o.ilosc);
    var pr = liczba(o.prog);
    if (prawda(o.sledzony) && il > 0 && pr > 0 && il <= pr && swieze(o.epoch, o.progH, o.teraz)) return 'low';
    return 'in';
  }

  // 'YYYY-MM-DD' -> poczatek nastepnego dnia (czas lokalny przegladarki) w ms; zly format = NaN.
  function koniecDnia(data) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(data == null ? '' : data).trim());
    if (!m) return NaN;
    var r = +m[1];
    var mies = +m[2];
    var d = +m[3];
    if (mies < 1 || mies > 12 || d < 1 || d > 31) return NaN;
    var dzien = new Date(r, mies - 1, d);
    if (dzien.getMonth() !== mies - 1) return NaN;
    return new Date(r, mies - 1, d + 1).getTime();
  }

  /*
   * Etykieta do pokazania (D17): reczne nadpisanie (custom.etykieta_override) wygrywa z automatem
   * (self.etykieta) do dnia custom.override_do WLACZNIE. Nadpisanie bez daty = wazne bezterminowo
   * (czlowiek ustawil je swiadomie; pole daty jest opcjonalne). Zla data = nadpisanie niewazne.
   * "Bez etykiety" = swiadomie nic. Automat "Ostatnie rozmiary" (claim o stanie) tylko przy swiezych
   * stanach (D19); ta sama etykieta wpisana recznie zostaje - to decyzja czlowieka.
   * Wynik: tekst etykiety albo '' (nic).
   */
  function etykieta(o) {
    o = o || {};
    var auto = ETYKIETY.indexOf(o.automat) >= 0 ? o.automat : '';
    if (auto === 'Ostatnie rozmiary' && !swieze(o.epoch, o.progH, o.teraz)) auto = '';

    var ov = String(o.override == null ? '' : o.override).trim();
    if (ov !== BEZ_ETYKIETY && ETYKIETY.indexOf(ov) < 0) return auto;

    var doDnia = String(o.overrideDo == null ? '' : o.overrideDo).trim();
    if (doDnia) {
      var koniec = koniecDnia(doDnia);
      var t = liczba(o.teraz);
      if (!(koniec > 0) || !(t > 0) || t >= koniec) return auto;
    }
    return ov === BEZ_ETYKIETY ? '' : ov;
  }

  function klasaEtykiety(tekst) {
    return KLASY[tekst] || '';
  }

  // NIP: 10 cyfr, opcjonalny prefiks PL, spacje i myslniki dozwolone; suma kontrolna wagami 6,5,7,2,3,4,5,6,7.
  function normalizujNip(x) {
    return String(x == null ? '' : x)
      .toUpperCase()
      .replace(/^\s*PL/, '')
      .replace(/[\s-]/g, '');
  }

  function nipPoprawny(x) {
    var n = normalizujNip(x);
    if (!/^\d{10}$/.test(n)) return false;
    var wagi = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var suma = 0;
    for (var i = 0; i < 9; i++) suma += wagi[i] * +n.charAt(i);
    var k = suma % 11;
    return k !== 10 && k === +n.charAt(9);
  }

  var NIP_BLEDNY = 'Sprawdź NIP - powinien mieć 10 cyfr i poprawną cyfrę kontrolną.';
  var NIP_PUSTY = 'Wpisz NIP albo odznacz fakturę na firmę.';
  var NIP_ZAPISANY = 'Zapisaliśmy NIP do zamówienia.';

  // Ocena wpisu: stan 'pusty' | 'poprawny' | 'bledny'; wartosc = 10 cyfr tylko przy poprawnym.
  function ocenNip(x) {
    var surowy = String(x == null ? '' : x).trim();
    if (!surowy) return { stan: 'pusty', wartosc: '' };
    if (!nipPoprawny(surowy)) return { stan: 'bledny', wartosc: '' };
    return { stan: 'poprawny', wartosc: normalizujNip(surowy) };
  }

  /*
   * Decyzja dla pola NIP (E4.14): co zapisac w atrybucie koszyka i czy wolno przejsc do kasy.
   * chce = zaznaczone "Chce fakture na firme". Zasada: koszyk nigdy nie trzyma NIP-u innego niz ten, ktory
   * klientka widzi - bledny, pusty albo odznaczony = atrybut '' (Shopify usuwa atrybut z pusta wartoscia).
   * Wynik: { atrybut, kasa (czy "Do kasy" przechodzi), stan, komunikat (blad do pokazania przy probie kasy) }.
   */
  function decyzjaNip(chce, x) {
    if (!chce) return { atrybut: '', kasa: true, stan: 'nie-chce', komunikat: '' };
    var o = ocenNip(x);
    if (o.stan === 'poprawny') return { atrybut: o.wartosc, kasa: true, stan: o.stan, komunikat: '' };
    return { atrybut: '', kasa: false, stan: o.stan, komunikat: o.stan === 'pusty' ? NIP_PUSTY : NIP_BLEDNY };
  }

  // ---------------------------------------------------------------------------------------------
  // DOM

  var SEL_STAN = '[data-self-stan]';
  var SEL_ETYKIETA = '[data-self-etykieta]';

  function teraz() {
    return Date.now();
  }

  function zastosujStan(el) {
    var d = el.dataset;
    var stan = stanWariantu({
      dostepny: d.dostepny,
      sledzony: d.sledzony,
      ilosc: d.ilosc,
      prog: d.prog,
      epoch: d.stanyEpoch,
      progH: d.progH,
      teraz: teraz(),
    });
    if (stan !== 'low') return;
    el.classList.remove('spp-dot--in');
    el.classList.add('spp-dot--low');
    var txt = el.parentNode && el.parentNode.querySelector('[data-self-stan-tekst]');
    if (txt && d.tekstNiski) txt.textContent = d.tekstNiski;
  }

  function zastosujEtykiete(el) {
    var d = el.dataset;
    var tekst = etykieta({
      automat: d.automat,
      override: d.override,
      overrideDo: d.overrideDo,
      epoch: d.stanyEpoch,
      progH: d.progH,
      teraz: teraz(),
    });
    for (var k in KLASY) {
      if (Object.prototype.hasOwnProperty.call(KLASY, k)) el.classList.remove('self-etykieta--' + KLASY[k]);
    }
    if (!tekst) {
      el.textContent = '';
      el.hidden = true;
      return;
    }
    el.textContent = tekst;
    el.classList.add('self-etykieta--' + klasaEtykiety(tekst));
    el.hidden = false;
  }

  function przetworz(korzen) {
    if (!korzen || !korzen.querySelectorAll) return;
    var lista = [];
    if (korzen.matches && (korzen.matches(SEL_STAN) || korzen.matches(SEL_ETYKIETA))) lista.push(korzen);
    var znalezione = korzen.querySelectorAll(SEL_STAN + ',' + SEL_ETYKIETA);
    for (var i = 0; i < znalezione.length; i++) lista.push(znalezione[i]);
    for (var j = 0; j < lista.length; j++) {
      var el = lista[j];
      try {
        if (el.hasAttribute('data-self-stan')) zastosujStan(el);
        else zastosujEtykiete(el);
      } catch (e) {
        /* blad jednego elementu nie zatrzymuje reszty; bez JS zostaje render Liquid */
      }
    }
  }

  // --- NIP (E4.14): pole w bloku [data-self-nip-blok], checkbox [data-self-nip-chce], status #SelfNipStan-*.

  function blokNip(input) {
    return input.closest ? input.closest('[data-self-nip-blok]') : null;
  }

  function chceNip(input) {
    var blok = blokNip(input);
    var ch = blok ? blok.querySelector('[data-self-nip-chce]') : null;
    return ch ? ch.checked : true;
  }

  function komunikatNip(input, tekst, blad) {
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/);
    var info = ids.length ? document.getElementById(ids[ids.length - 1]) : null;
    if (info) {
      info.textContent = tekst;
      if (info.classList) info.classList.toggle('self-nip__stan--blad', !!blad);
    }
    if (blad) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  // Zapis atrybutu w tle (dla szybkich platnosci w koszyku, ktore omijaja formularz). Blad = komunikat, bez zapisu.
  function zapiszNip(input) {
    var d = decyzjaNip(chceNip(input), input.value);
    var pokazBlad = d.stan === 'bledny';
    if (pokazBlad) komunikatNip(input, d.komunikat, true);
    else if (d.atrybut) input.value = d.atrybut;

    var zapisany = input.getAttribute('data-self-nip-zapisany') || '';
    if (d.atrybut === zapisany) {
      if (!pokazBlad) komunikatNip(input, d.atrybut ? NIP_ZAPISANY : '', false);
      return;
    }
    var nazwa = input.getAttribute('data-self-nip') || 'NIP';
    var dane = new FormData();
    dane.append('attributes[' + nazwa + ']', d.atrybut);
    var korzen = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    fetch(korzen + 'cart/update.js', { method: 'POST', body: dane, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (koszyk) {
        var zapisanyTeraz = (koszyk && koszyk.attributes && koszyk.attributes[nazwa]) || '';
        if (zapisanyTeraz !== d.atrybut) throw new Error('atrybut');
        input.setAttribute('data-self-nip-zapisany', d.atrybut);
        if (!pokazBlad) komunikatNip(input, d.atrybut ? NIP_ZAPISANY : '', false);
      })
      .catch(function () {
        komunikatNip(input, 'Nie udało się zapisać NIP. Spróbuj ponownie.', true);
      });
  }

  // "Do kasy": formularz koszyka niesie pole NIP (atrybut `form`). Bledny albo pusty przy zaznaczonej fakturze = stop.
  function sprawdzNipPrzedKasa(ev) {
    var form = ev.target;
    if (!form || !form.id || !document.querySelectorAll) return;
    var pola = document.querySelectorAll('input[data-self-nip][form="' + form.id + '"]');
    for (var i = 0; i < pola.length; i++) {
      var input = pola[i];
      var d = decyzjaNip(chceNip(input), input.value);
      if (!d.kasa) {
        ev.preventDefault();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        komunikatNip(input, d.komunikat, true);
        input.focus();
        return;
      }
      input.value = d.atrybut;
    }
  }

  function zmianaChceNip(ch) {
    var blok = ch.closest ? ch.closest('[data-self-nip-blok]') : null;
    var input = blok ? blok.querySelector('input[data-self-nip]') : null;
    if (!input) return;
    if (ch.checked) {
      // Pole odkrywa CSS (:has) - fokus po przeliczeniu stylu.
      setTimeout(function () {
        input.focus();
      }, 0);
      return;
    }
    input.value = '';
    komunikatNip(input, '', false);
    zapiszNip(input);
  }

  function start() {
    przetworz(document);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (zmiany) {
        for (var i = 0; i < zmiany.length; i++) {
          var dodane = zmiany[i].addedNodes;
          for (var j = 0; j < dodane.length; j++) {
            if (dodane[j].nodeType === 1) przetworz(dodane[j]);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-self-nip]')) zapiszNip(t);
      else if (t.matches('input[data-self-nip-chce]')) zmianaChceNip(t);
    });
    document.addEventListener('submit', sprawdzNipPrzedKasa, true);
  }

  var api = {
    wersja: '1.1.0',
    ETYKIETY: ETYKIETY.slice(),
    BEZ_ETYKIETY: BEZ_ETYKIETY,
    swieze: swieze,
    stanWariantu: stanWariantu,
    koniecDnia: koniecDnia,
    etykieta: etykieta,
    klasaEtykiety: klasaEtykiety,
    normalizujNip: normalizujNip,
    nipPoprawny: nipPoprawny,
    ocenNip: ocenNip,
    decyzjaNip: decyzjaNip,
    przetworz: przetworz,
  };
  root.SelfStany = api;

  if (typeof document !== 'undefined' && document.documentElement) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})(typeof window !== 'undefined' ? window : globalThis);
